

import React, {useContext, useEffect, useState} from "react";

export const AuthContext = React.createContext(null)

export const useAuth = () => {
    const context = useContext(AuthContext)
    if (!context) throw new Error("useAuth must be used inside Auth Context")
    return context
}

const AuthProvider = ({children}) => {
    const [auth, setAuth] = useState({
      token:'',
      username:'',
      timestamp:0,
      isAuth:false
    })

    useEffect(() => {
      // reset login session if less than day from login
      let token = localStorage.getItem('token') || '',
          timestamp = localStorage.getItem('timestamp') || 0,
          username = localStorage.getItem('username') || '',
          timeout = 86400000 // msecs timeout

      if (token !== '' && ( Date.now() - timestamp < timeout ) && username !== ''){
          setAuth({token:token, username:username, timestamp:timestamp ,isAuth:true})
      }
    },[])

    return <AuthContext.Provider children={children} value={{auth, setAuth}}/>
}
export default AuthProvider
